<script setup>
import { ErrorMessage } from 'vee-validate';

const props = defineProps({
  label: {
    required: true,
  },
  inputType: {
    default: 'text',
  },
  autoCompleteType: {
    default: null,
  },
  id: {
    required: true,
  },
  isRequired: {
    default: false,
  },
});

const model = defineModel();
</script>

<template>
  <div class="mt-6">
    <label v-if="props.isRequired"
      :for="props.id"
      class="block text-sm font-medium text-primary"
    >{{ label }} *</label>
    <label v-else
           :for="props.id"
           class="block text-sm font-medium text-primary"
    >{{ label }}</label>
    <div class="mt-3">
      <input
        v-bind="$attrs"
        :id="props.id"
        v-model="model"
        :type="props.inputType"
        class="block w-full input-transparent-text"
        :required="props.isRequired"
        :autocomplete="props.autoCompleteType"
      >
      <slot />
      <ErrorMessage
        :name="props.id"
        class="px-2 mt-2 text-sm text-red-400 dark:text-red-400"
        as="p"
        v-slot="{ message }"
      >
        <div v-html="message" />
      </ErrorMessage>
    </div>
  </div>
</template>
